export function getRoleLabel(role: string, is_ceo?: boolean): string {
  if (is_ceo) return "Zarząd";
  const labels: Record<string, string> = {
    director: "Dyrektor",
    coordinator: "Koordynator",
    accountant: "Księgowy",
    employee: "Pracownik",
    hr: "Kadrowa",
    contractor: "Podwykonawca",
  };
  return labels[role] ?? role;
}

export function getRoleBadgeColor(
  role: string,
  is_ceo?: boolean
): "black" | "red" | "orange" | "gray" | "yellow" | "purple" | "green" | "blue" {
  if (is_ceo) return "black";
  if (role === "director") return "red";
  if (role === "coordinator") return "orange";
  if (role === "employee") return "gray";
  if (role === "contractor") return "yellow";
  if (role === "accountant") return "purple";
  if (role === "hr") return "green";
  return "gray";
}
